import { Action } from "@ngrx/store";
import { ReduxAction } from "./../actions/redux.action";

export function TestOrderSearchReducer(
  state: SearchCriteria,
  action: ReduxAction
) {
  switch (action.type) {
    case "SET_TEST_ORDER_SEARCH_CRITERIA":
      return Object.assign({}, state, action.get());

    case "LOGOUT":
    case "CLEAR_SEARCH":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/reducers/test-order-search.reducer.ts